module.exports = __webpack_public_path__ + "static/media/cases_impressos_rimac_02.4ba51359.jpg";